<script>
    import PreviewSection from "./PreviewSection";
    import BundleOverviewSection from "../../components/pagesbuilder/sections/BundleOverviewSection";

    export default {
        name: "PreviewBundleOverviewSection",
        mixins: [PreviewSection,BundleOverviewSection]
    }
</script>
